import styled from '@emotion/styled';
import { Col as GridCol } from '../../components/Grid';

export const Wrapper = styled.section`
  position: relative;
  display: flex;
  align-items: flex-end;
  overflow: hidden;

  ${({ theme }) => theme.media.tablet} {
    padding-top: 0;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  right: ${({ right }) => right || 0};
  transform: translate(0, -50%) ${({ scale }) => `scale(${scale || 1})`};
  top: ${({ top }) => top || '50%'};

  max-width: ${({ small }) => (small ? '46.5rem' : '32rem')};
  width: ${({ small }) => (small ? '60%' : '45%')};

  ${({ theme }) => theme.media.tablet} {
    display: none;
  }
`;

export const Col = styled(GridCol)`
  display: flex;

  ${({ theme }) => theme.media.desktop} {
    h4 {
      font-size: calc(14px + (24 - 14) * (100vw - 950px) / (1440 - 950)) !important;
    }
  }
  ${({ theme }) => theme.media.tablet} {
    h4 {
      font-size: calc(14px + (24 - 14) * (100vw - 450px) / (950 - 450)) !important;
    }
  }

  ${({ theme }) => theme.media.mobile} {
    h4 {
      font-size: 24px !important;
    }
  }
`;
